import { SessionMentorStatus } from '@/queries/constants'

import type { FormInputType } from '@/components/UI/Form/types'

export default function getChangeMentorStatusFormInputs(): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      type: 'select',
      label: 'Choose a status',
      name: 'status',
      required: true,
      options: [
        { label: 'Needs Mentor', value: SessionMentorStatus.NeedsMentor },
        { label: 'In Progress', value: SessionMentorStatus.InProgress },
        { label: 'Resolved', value: SessionMentorStatus.Resolved },
      ],
      size: 6,
    },
    {
      label: 'Add a note',
      sublabel:
        'Describe why you’re changing the status and any relevant actions you’ve taken for the tutor.',
      type: 'textarea',
      name: 'comment',
      required: true,
      size: 6,
    },
  ]
  return formInputs
}
